import { concatMap, Subject, of, delay, tap, map, BehaviorSubject } from 'rxjs';
import { ViewerMessage } from '../library/types/ViewerMessage';
import { defaultDismissTimeout, SNACKBAR_VARIANT, SnackbarComponentProps, SnackbarMessage } from '../library/components/snackbar.component';
import { generateId } from '../library/utilities/generate-id';

export const infoSubject$ = new Subject<ViewerMessage>();
export const infoObservable$ = infoSubject$.asObservable();

// queue messages to be displayed for the dismiss timeout...
export const snackbarQueue$ = new BehaviorSubject<SnackbarMessage | null>(null);

let counter = 0;

export const testSnackbarQueue = () => {
    counter = counter + 1;

    const variants = Object.values(SNACKBAR_VARIANT);
    const randomVariant = variants[Math.floor(Math.random() * variants.length)];
    const messages = [
        'The operation completed successfully.',
        'Something might need your attention.',
        'Oops! Something went wrong.',
        'Check your internet connection.',
        'Update available!',
        'Task completed with warnings.',
        'New data has been synced.',
        'Action required from your side.',
        'Timeout occurred during the request.',
        'All systems are operational.'
    ];
    const randomMessage = messages[Math.floor(Math.random() * messages.length)];
    const randomDismissTimeout = Math.floor(Math.random() * (5000 - 1500 + 1)) + 1500;

    const headings = [`Message #${counter}`, 'Heads up!', 'Success', 'Warning', undefined];
    const randomHeading = headings[Math.floor(Math.random() * headings.length)];

    const actions = [
        undefined,
        { label: 'Retry', actionClick: () => console.log('Retry clicked') },
        { label: 'Details', actionClick: () => console.log('Details clicked') },
        { label: 'Dismiss', actionClick: () => console.log('Dismiss clicked') }
    ];
    const randomAction = actions[Math.floor(Math.random() * actions.length)];

    snackbarQueue$.next({
        variant: randomVariant,
        message: randomMessage,
        action: randomAction,
        dismissTimeout: randomDismissTimeout,
        heading: randomHeading
    });
};
